import { appLocales } from 'features/i18n/locales';
import type { AppLocales, DefaultLocale } from '@hub/common';

/**
 * Get the app locale from the string that represents locale
 * @param locale
 * @returns
 */
export const getAppLocale = (locale: string | undefined): AppLocales => {
  const defaultLocale: DefaultLocale = 'en-US';
  if (!locale) return defaultLocale;

  if (appLocales.includes(locale as AppLocales)) return locale as AppLocales;

  const [language] = locale.split('-');

  if (!language) return defaultLocale;

  const localeMatch = appLocales.find(l =>
    l.startsWith(language.toLowerCase())
  );

  return localeMatch ?? defaultLocale;
};
